import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Gift = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12 3.75V20.25M2.25 12H21.75M6.375 17.25C7.66793 17.25 8.90791 16.7364 9.82215 15.8221C10.7364 14.9079 11.25 13.6679 11.25 12.375V12M17.625 17.25C16.3321 17.25 15.0921 16.7364 14.1779 15.8221C13.2636 14.9079 12.75 13.6679 12.75 12.375V12M3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25ZM16.371 10.81C14.962 12.22 12.129 11.871 12.129 11.871C12.129 11.871 11.78 9.038 13.189 7.629C13.611 7.20704 14.1833 6.96999 14.78 6.96999C15.3767 6.96999 15.949 7.20704 16.371 7.629C16.793 8.05096 17.03 8.62326 17.03 9.22C17.03 9.81674 16.793 10.388 16.371 10.81ZM10.773 7.63C12.182 9.039 11.833 11.872 11.833 11.872C11.833 11.872 9 12.22 7.592 10.811C7.38307 10.6021 7.21733 10.354 7.10426 10.081C6.99118 9.80806 6.93299 9.51548 6.93299 9.22C6.93299 8.92452 6.99118 8.63194 7.10426 8.35896C7.21733 8.08597 7.38307 7.83793 7.592 7.629C7.80093 7.42007 8.04897 7.25433 8.32196 7.14126C8.59494 7.02818 8.88752 6.96999 9.183 6.96999C9.47848 6.96999 9.77106 7.02818 10.044 7.14126C10.317 7.25433 10.5651 7.42007 10.774 7.629L10.773 7.63Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Gift };